import {END, READY, REGISTER} from 'shared/constant/lookup/eventState'
import timestampCalculator from 'shared/lib/timestampCalculator'
import Badge from '../ScanResultBottomSheet/ui/Badge'
import RefreshButton from '../ScanResultBottomSheet/ui/RefreshButton'
import Style from './style'

const TournamentInfo = ({data, tournamentName, refetch, isLoading}) => {
	const {
		can_eliminate,
		event_state,
		user_can_join,
		event_date,
		event_reg_date,
	} = data || {}

	const {max_reentry, count} = data?.participation_history || {}
	const {rest_player, total_player, level} = data?.event_timer || {}

	const reEntryCount = count && count > 0 ? count - 1 : 0

	const isHideLabel =
		event_state === END ||
		event_state === REGISTER ||
		event_state === READY ||
		can_eliminate
	const rowData = [
		{
			title: '접수 시간',
			value: event_reg_date ? timestampCalculator(event_reg_date) : '-',
		},
		{
			title: '대회 시간',
			value: event_date ? timestampCalculator(event_date) : '-',
		},
		{
			title: '현재 레벨',
			value: `${level || '1'}`,
		},
		{
			title: '플레이어 / 참가자',
			value: `${rest_player || 0}/${total_player || 0}`,
		},
		{
			title: '재입장 사용',
			value: `${reEntryCount}/${max_reentry || '-'}`,
			hidden: isHideLabel,
			highlight: reEntryCount && max_reentry && reEntryCount >= max_reentry,
		},
	]

	return (
		<Style.Container>
			<Style.NameRow>
				<Style.SectionTitle>대회 정보</Style.SectionTitle>
				<RefreshButton onClick={refetch} loading={isLoading} />
			</Style.NameRow>

			<Style.ContentContainer>
				<Style.NameRow>
					<Style.TournamentName>{tournamentName}</Style.TournamentName>
					<Badge
						user_can_join={user_can_join}
						isTourInfo
						event_state={event_state}
					/>
				</Style.NameRow>

				{rowData.map((elem) => {
					if (elem?.hidden) return null
					return (
						<Style.InfoRow>
							<Style.Label highlight={elem?.highlight}>
								{elem.title}:{' '}
							</Style.Label>
							<Style.Value highlight={elem?.highlight}>
								{elem.value}
							</Style.Value>
						</Style.InfoRow>
					)
				})}
			</Style.ContentContainer>
		</Style.Container>
	)
}

export default TournamentInfo
